import { hiCol } from 'components/grid/hiGrid';

const YN_OPTIONS = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
];

const DEGREE_OPTIONS = [
  { value: 'HIGH_SCHOOL', label: '고등학교' },
  { value: 'ASSOCIATE', label: '전문학사' },
  { value: 'BACHELOR', label: '학사' },
  { value: 'MASTER', label: '석사' },
  { value: 'DOCTOR', label: '박사' },
  { value: 'ETC', label: '기타' },
];

const AWARD_TYPE_OPTIONS = [
  { value: 'AWARD', label: '표창' },
  { value: 'DISCIPLINE', label: '징계' },
];

const RELATION_OPTIONS = [
  { value: 'SPOUSE', label: '배우자' },
  { value: 'CHILD', label: '자녀' },
  { value: 'PARENT', label: '부모' },
  { value: 'SIBLING', label: '형제자매' },
  { value: 'ETC', label: '기타' },
];

const GENDER_OPTIONS = [
  { value: 'M', label: '남' },
  { value: 'F', label: '여' },
  { value: 'U', label: '미상' },
];

/** 인사기록카드 탭별 그리드 설정 */
export const EMPLOYEE_RECORD_TABS = [
  {
    id: 'education',
    label: '학력',
    section: 'education',
    selectQuery: 'EmployeeRecord.selectEducationList',
    defaultRow: {
      schoolNm: '',
      majorNm: '',
      degreeCode: 'BACHELOR',
      admissionDate: '',
      graduationDate: '',
      graduateYn: 'Y',
      sortOrder: 0,
      remark: '',
    },
    columns: () => [
      hiCol.edTextColumn({ header: '학교명', field: 'schoolNm', size: 140, required: true }),
      hiCol.edTextColumn({ header: '전공', field: 'majorNm', size: 100 }),
      hiCol.edComboColumn({ header: '학위', field: 'degreeCode', size: 90, options: DEGREE_OPTIONS, required: true }),
      hiCol.edDateColumn({ header: '입학일', field: 'admissionDate', size: 100 }),
      hiCol.edDateColumn({ header: '졸업일', field: 'graduationDate', size: 100 }),
      hiCol.edComboColumn({ header: '졸업', field: 'graduateYn', size: 60, options: YN_OPTIONS }),
      hiCol.edNumberColumn({ header: '순서', field: 'sortOrder', size: 60 }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
  {
    id: 'career',
    label: '경력',
    section: 'career',
    selectQuery: 'EmployeeRecord.selectCareerList',
    defaultRow: {
      companyNm: '',
      deptNm: '',
      positionNm: '',
      startDate: '',
      endDate: '',
      careerMonths: null,
      remark: '',
    },
    columns: () => [
      hiCol.edTextColumn({ header: '근무처', field: 'companyNm', size: 140, required: true }),
      hiCol.edTextColumn({ header: '부서', field: 'deptNm', size: 100 }),
      hiCol.edTextColumn({ header: '직위', field: 'positionNm', size: 90 }),
      hiCol.edDateColumn({ header: '시작일', field: 'startDate', size: 100, required: true }),
      hiCol.edDateColumn({ header: '종료일', field: 'endDate', size: 100 }),
      hiCol.edNumberColumn({ header: '경력(월)', field: 'careerMonths', size: 80 }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
  {
    id: 'awardDiscipline',
    label: '상벌',
    section: 'awardDiscipline',
    selectQuery: 'EmployeeRecord.selectAwardDisciplineList',
    defaultRow: {
      typeCode: 'AWARD',
      titleNm: '',
      actionDate: '',
      orgNm: '',
      gradeNm: '',
      remark: '',
    },
    columns: () => [
      hiCol.edComboColumn({ header: '구분', field: 'typeCode', size: 80, options: AWARD_TYPE_OPTIONS, required: true }),
      hiCol.edTextColumn({ header: '표창/징계명', field: 'titleNm', size: 160, required: true }),
      hiCol.edDateColumn({ header: '일자', field: 'actionDate', size: 100, required: true }),
      hiCol.edTextColumn({ header: '시행기관', field: 'orgNm', size: 120 }),
      hiCol.edTextColumn({ header: '등급', field: 'gradeNm', size: 90 }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
  {
    id: 'training',
    label: '교육이수',
    section: 'training',
    selectQuery: 'EmployeeRecord.selectTrainingList',
    defaultRow: {
      courseNm: '',
      orgNm: '',
      startDate: '',
      endDate: '',
      trainingHours: null,
      completeYn: 'Y',
      remark: '',
    },
    columns: () => [
      hiCol.edTextColumn({ header: '교육과정', field: 'courseNm', size: 160, required: true }),
      hiCol.edTextColumn({ header: '교육기관', field: 'orgNm', size: 120 }),
      hiCol.edDateColumn({ header: '시작일', field: 'startDate', size: 100 }),
      hiCol.edDateColumn({ header: '종료일', field: 'endDate', size: 100 }),
      hiCol.edNumberColumn({ header: '이수시간', field: 'trainingHours', size: 80 }),
      hiCol.edComboColumn({ header: '이수', field: 'completeYn', size: 60, options: YN_OPTIONS }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
  {
    id: 'family',
    label: '가족',
    section: 'family',
    selectQuery: 'EmployeeRecord.selectFamilyList',
    defaultRow: {
      relationCode: 'SPOUSE',
      familyNm: '',
      birthDate: '',
      genderCode: 'U',
      cohabitYn: 'Y',
      dependentYn: 'N',
      remark: '',
    },
    columns: () => [
      hiCol.edComboColumn({ header: '관계', field: 'relationCode', size: 90, options: RELATION_OPTIONS, required: true }),
      hiCol.edTextColumn({ header: '성명', field: 'familyNm', size: 100, required: true }),
      hiCol.edDateColumn({ header: '생년월일', field: 'birthDate', size: 100 }),
      hiCol.edComboColumn({ header: '성별', field: 'genderCode', size: 70, options: GENDER_OPTIONS }),
      hiCol.edComboColumn({ header: '동거', field: 'cohabitYn', size: 60, options: YN_OPTIONS }),
      hiCol.edComboColumn({ header: '부양', field: 'dependentYn', size: 60, options: YN_OPTIONS }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
  {
    id: 'license',
    label: '자격증',
    section: 'license',
    selectQuery: 'EmployeeRecord.selectLicenseList',
    defaultRow: {
      licenseNm: '',
      issueOrgNm: '',
      licenseNo: '',
      acquireDate: '',
      expireDate: '',
      remark: '',
    },
    columns: () => [
      hiCol.edTextColumn({ header: '자격증명', field: 'licenseNm', size: 140, required: true }),
      hiCol.edTextColumn({ header: '발급기관', field: 'issueOrgNm', size: 120 }),
      hiCol.edTextColumn({ header: '자격번호', field: 'licenseNo', size: 110 }),
      hiCol.edDateColumn({ header: '취득일', field: 'acquireDate', size: 100 }),
      hiCol.edDateColumn({ header: '만료일', field: 'expireDate', size: 100 }),
      hiCol.edTextColumn({ header: '비고', field: 'remark', size: 120 }),
    ],
  },
];
